
import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'
import InvoiceReceiptTransformer from '@/transformers/invoiceReceipt'

export default (invoiceReceipt) => {
  const payload = InvoiceReceiptTransformer.send(invoiceReceipt)
  return errorHandler(Vue.$http.put(`taxreceipt/invoicereceipt/${invoiceReceipt.id}/stamped-file/`,
                       payload, {
                         headers: { 'Content-Type': 'multipart/form-data' }
                       }))
    .then(response => InvoiceReceiptTransformer.fetch(response.data))
}



// WEBPACK FOOTER //
// ./src/services/taxReceipt/uploadStampedInvoiceReceipt.js